import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { BonusPreviews } from '../components/BonusPreviews';
import { OfferSection } from '../components/OfferSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="w-full min-h-screen bg-bg-primary" data-id="element-337">
      <UrgencyBar data-id="element-338" />
      <SocialProofPopup data-id="element-339" />
      <main data-id="element-340">
        <HeroSection data-id="element-341" />
        <PainSection data-id="element-342" />
        <RevelationSection data-id="element-343" />
        <BonusPreviews data-id="element-344" />
        <OfferSection data-id="element-345" />
        <FAQSection data-id="element-346" />
        <GuaranteeSection data-id="element-347" />
      </main>
      <Footer data-id="element-348" />
    </div>;
}